import React from 'react';

// Mesmas cores dos SELOS da Home (containers/Home/styles.js).
const TONS = {
    ok: { background: '#E4EFDF', color: '#1F4615' },
    alerta: { background: '#FFF3DC', color: '#7A4A05' },
    erro: { background: '#FBE6DF', color: '#8E2F12' },
    info: { background: '#E3ECFB', color: '#1E3F8A' },
    neutro: { background: '#EEF1EC', color: '#3D4A38' },
    oportunidade: { background: '#D9F2EC', color: '#0E5A4C' },
};

export const normalizar = (v) => String(v === null || v === undefined ? '' : v)
    .trim()
    .toLowerCase()
    .normalize('NFD').replace(/[̀-ͯ]/g, '')
    .replace(/\s+/g, '_');

// Cada tipo aceita o código gravado no banco OU o texto já traduzido que a API devolve.
const MAPAS = {
    confirmacao: {
        '': ['Em branco', 'neutro'], em_branco: ['Em branco', 'neutro'],
        aguardando: ['Aguardando', 'alerta'],
        // mesmas cores do calendário: confirmada = azul, realizada = verde, não confirmada = amarelo
        confirmado: ['Confirmada', 'info'], confirmada: ['Confirmada', 'info'],
        realizada: ['Realizada', 'ok'], realizado: ['Realizada', 'ok'],
        reagendada: ['Reagendada', 'alerta'], reagendado: ['Reagendada', 'alerta'],
        aguardando_nova_data: ['Aguardando nova data', 'alerta'],
        declinada: ['Declinada', 'erro'], declinado: ['Declinada', 'erro'],
        nao_aprovada: ['Não aprovada', 'erro'], nao_aprovado: ['Não aprovada', 'erro'],
        oportunidade: ['Oportunidade', 'oportunidade'], oportunidades: ['Oportunidade', 'oportunidade'],
    },
    auditoria: {
        '': ['Em branco', 'neutro'], em_branco: ['Em branco', 'neutro'],
        1: ['Aprovada', 'ok'], aprovada: ['Aprovada', 'ok'], aprovado: ['Aprovada', 'ok'],
        2: ['Aguardando', 'alerta'], aguardando: ['Aguardando', 'alerta'],
        3: ['Não aprovada', 'erro'], nao_aprovada: ['Não aprovada', 'erro'], nao_aprovado: ['Não aprovada', 'erro'],
    },
    briefing: {
        '': ['Em branco', 'neutro'], em_branco: ['Em branco', 'neutro'],
        0: ['Aguardando', 'alerta'], aguardando: ['Aguardando', 'alerta'], false: ['Aguardando', 'alerta'],
        1: ['Enviado', 'ok'], enviado: ['Enviado', 'ok'], true: ['Enviado', 'ok'],
    },
    lead: {
        8: ['Em branco', 'neutro'], em_branco: ['Em branco', 'neutro'],
        1: ['Em andamento', 'info'], 2: ['Retorno futuro', 'neutro'], 3: ['Aguardando retorno', 'alerta'],
        4: ['Sem interesse', 'erro'], 5: ['Sem perfil', 'erro'], 6: ['Black list', 'erro'], 7: ['Reunião agendada', 'ok'],
    },
};

/** Tom e rótulo de um status; exportado para o calendário colorir os eventos. */
export const statusInfo = (tipo, valor) => {
    const mapa = MAPAS[tipo] || {};
    const achado = mapa[normalizar(valor)];
    if (achado) return { rotulo: achado[0], tom: achado[1], ...TONS[achado[1]] };
    return { rotulo: String(valor), tom: 'neutro', ...TONS.neutro };
};

/** Selo de status com cor e texto (a cor nunca é a única informação). */
const StatusChip = ({ tipo, valor, style }) => {
    const info = statusInfo(tipo, valor);
    return (
        <span
            style={{
                display: 'inline-block',
                fontSize: 12,
                fontWeight: 600,
                lineHeight: '18px',
                padding: '2px 8px',
                borderRadius: 6,
                whiteSpace: 'nowrap',
                background: info.background,
                color: info.color,
                ...style,
            }}
        >
            {info.rotulo}
        </span>
    );
};

export default StatusChip;
